import { useState } from 'react';
import { MOCK_USERS } from '../../assets/mockData';
import { useMessages } from '../../contexts/MessageContext';
import ChatWindow from './ChatWindow';

function AvatarSmall({ name }) {
  const colors = ['#6c5ce7', '#00b894', '#e17055', '#0984e3', '#fdcb6e', '#e84393'];
  const color = colors[name.charCodeAt(0) % colors.length];
  return (
    <div className="avatar-small" style={{ background: color }}>
      {name[0]}
    </div>
  );
}

function formatTime(ts) {
  const now = new Date();
  const d = new Date(ts);
  const diff = now - d;

  if (diff < 86400000 && now.getDate() === d.getDate()) {
    return `${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
  }
  if (diff < 172800000) return '昨天';
  return `${d.getMonth() + 1}/${d.getDate()}`;
}

export default function ChatList() {
  const { conversations } = useMessages();
  const [activeConv, setActiveConv] = useState(null);

  if (activeConv) {
    const conv = conversations.find((c) => c.id === activeConv);
    if (conv) {
      return <ChatWindow conversation={conv} onBack={() => setActiveConv(null)} />;
    }
  }

  return (
    <div className="chat-list-container">
      <h2 className="page-title">私信</h2>
      {conversations.length === 0 ? (
        <div className="chat-empty">
          <div className="chat-empty-icon">💬</div>
          <p>暂无消息</p>
        </div>
      ) : (
        <div className="chat-list">
          {conversations.map((conv) => {
            const otherUserId = conv.participants.find((p) => p !== 'currentUser');
            const otherUser = MOCK_USERS.find((u) => u.id === otherUserId);
            const lastMsg = conv.messages.filter((m) => !m.recalled).slice(-1)[0];

            return (
              <div
                key={conv.id}
                className="chat-list-item"
                onClick={() => setActiveConv(conv.id)}
              >
                <AvatarSmall name={otherUser?.name || '?'} />
                <div className="chat-list-info">
                  <div className="chat-list-top">
                    <span className="chat-list-name">{otherUser?.name}</span>
                    {lastMsg && (
                      <span className="chat-list-time">
                        {formatTime(lastMsg.timestamp)}
                      </span>
                    )}
                  </div>
                  <div className="chat-list-preview">
                    {lastMsg
                      ? lastMsg.content.length > 30
                        ? lastMsg.content.slice(0, 30) + '...'
                        : lastMsg.content
                      : '暂无消息'}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
